export const JOURNEY_VIEW_TEST_ID = 'journeyView';
